import React from "react";
import PropTypes from "prop-types";

import BuscadorEstudiante from "../../components/BuscadorEstudiante";
import ListaEditable from "../../components/ListaEditable";

/**
 * Paso Estudiantes: quienes van. La lista llega con el grupo de la materia
 * (o con el estudiante que solicita, fijo) y se completa con el buscador.
 * Se marcan y desmarcan en vez de borrarse, para no perder a nadie del grupo.
 *
 * @param {Object} estudiantes la lista de useListaEditable.
 */
const PasoEstudiantes = ({ estudiantes, cargando, ayuda, onMensaje }) => (
  <ListaEditable
    items={estudiantes.items}
    onAlternar={estudiantes.alternar}
    textoVacio={
      cargando ? "Cargando los estudiantes del grupo..." : "Busque al menos un estudiante"
    }
  >
    <BuscadorEstudiante
      onAgregar={estudiantes.agregar}
      onMensaje={onMensaje}
      excluir={estudiantes.items.map(({ identificacion }) => `${identificacion}`)}
      ayuda={ayuda}
    />
  </ListaEditable>
);

PasoEstudiantes.propTypes = {
  estudiantes: PropTypes.shape({
    items: PropTypes.array.isRequired,
    agregar: PropTypes.func.isRequired,
    alternar: PropTypes.func.isRequired,
  }).isRequired,
  cargando: PropTypes.bool,
  ayuda: PropTypes.string,
  onMensaje: PropTypes.func,
};

PasoEstudiantes.defaultProps = {
  cargando: false,
  ayuda: "",
  onMensaje: () => {},
};

export default PasoEstudiantes;
